module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-01-5f70735077dae90ca57d1c273c46896b.png";